// extracted by mini-css-extract-plugin
export default {"container":"image_container__48DKd","quoted":"image_quoted__kcwGt"};